/*------------------------------------------------------------------------------------------
* © 2020 KPMG LLP, a Delaware limited liability partnership and 
* a member firm of the KPMG global organization of independent member firms 
* affiliated with KPMG International Limited, a private English company limited by guarantee. 
* All rights reserved.
*-----------------------------------------------------------------------------------------*/
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ReportConfig, TileConfig } from '../models/powerbi.model';
import { ProjectReport } from '../models/project-report.model';
import { EnvSettingsService } from '../core/services/env-settings.service';



@Injectable()
export class PowerBIService {
  private _baseUri: string;
  constructor(private _httpClient: HttpClient, private _envSettings: EnvSettingsService) {
    this._baseUri = this._envSettings.getApiUrl();
  }

  getEmbedToken(projectId: number): Observable<ReportConfig> {
    return this._httpClient.get<ReportConfig>(`${this._baseUri}/api/v1/GenerateReport/GetEmbedUrl/${projectId}`);
  }
  getEmbedTokenTax(projectId: number,code:string): Observable<ReportConfig> {
    return this._httpClient.get<ReportConfig>(this._baseUri+'/api/v1/GenerateReport/GetEmbedUrlTax?projectId=' + projectId +'&code='+code);
  }
  
  getTileConfig(): Observable<TileConfig> {
    return this._httpClient.get<TileConfig>(this._baseUri + '/api/v1/report/TileConfig');
  }

  getReportStatus(projectId: number): Observable<ProjectReport> {
    return this._httpClient.get<ProjectReport>(`${this._baseUri}/api/v1/GenerateReport/GetReportStatus/${projectId}`);
  }
}
